import Model from '@/models/Model'

export default class Comment extends Model {
	static includes = [
		'pos_cash_desk', 
		'pos_cash_desk.g_branch_office', 
		'g_user', 
		'g_user.hr_employee', 
		'sl_ground_seller_payment_record', 
		'sl_ground_seller_payment_record.sl_ground_seller', 
		'sl_ground_seller_payment_record.sl_ground_seller.hr_employee', 
		'sl_ground_seller_payment_record.sl_customer', 
		'sl_ground_seller_payment_record.sl_customer.pch_payment_condition', 
		'sl_ground_seller_payment_record.sl_customer.sl_customer_account', 
		'sl_ground_seller_payment_record.sl_detail_ground_seller_payment_records', 
		'sl_ground_seller_payment_record.sl_detail_ground_seller_payment_records.sl_customer_account_receivable', 
		'sl_ground_seller_payment_record.sl_detail_ground_seller_payment_records.sl_customer_account_receivable.sl_sale_invoice', 
		'sl_customer', 
		'sl_customer.sl_customer_account', 
		'sl_customer.sl_ground_seller', 
		'sl_customer.sl_ground_seller.hr_employee', 
		'sl_customer.sl_ground_seller.hr_employee.g_user', 
		'pos_detail_customer_receivable_payments', 
		'pos_detail_customer_receivable_payments.sl_customer_account_movement', 
		'pos_detail_customer_receivable_payments.sl_customer_account_movement.sl_type_customer_account_movement', 
		'pos_detail_customer_receivable_payments.sl_customer_receivable', 
		'pos_detail_customer_receivable_payments.sl_customer_receivable.sl_sale_invoice', 
		'pos_detail_customer_receivable_payments.sl_customer_receivable.sl_sale_debit_note', 
		'payments', 
		'payments.pos_sale_payment_type'
	]
	get payments_documents() {
		return this.pos_detail_customer_receivable_payments.length > 0 ?	
			this.pos_detail_customer_receivable_payments.map(
				payment => `${payment.sl_customer_receivable.document} - ${payment.sl_customer_receivable.sl_sale_invoice ? payment.sl_customer_receivable.sl_sale_invoice.number : payment.sl_customer_receivable.sl_sale_debit_note ? payment.sl_customer_receivable.sl_sale_debit_note.number : ''}`
			)
			.join(', ')
			:
			'-'
	}
	get payments_types() {
		return this.payments.length > 0 ? 
				this
					.payments
					.map(payment => `${payment.pos_sale_payment_type.type} - $ ${payment.amount}`).join(', ')
				:
				'-'
	}
  resource() {
    return 'pos_customer_receivable_payment'
  }
}
